import Dev from './Dev.png';
import Staging from './Staging.png';
import Prod from './Prod.png';
import { AppEnvironment } from '../../../../hooks/useEnvironment';

function getIcon() {
  switch (import.meta.env.VITE_MODE) {
    case AppEnvironment.Dev:
      return Dev;
    case AppEnvironment.Staging:
      return Staging;
    default:
      return Prod;
  }
}

export const Favicon = getIcon();
